import 'prop-types';
import styled from 'styled-components';
import { TREE_LINE_HEIGHT, TREE_HORIZONTAL_SEPARATION } from '../constants.js';

var TreeLabel = styled.div.withConfig({
  displayName: "TreeLabel",
  componentId: "sc-vvahe9-0"
})(function (_ref) {
  var isDragging = _ref.isDragging;
  return {
    cursor: "default",
    flex: 1,
    lineHeight: TREE_LINE_HEIGHT,
    marginInlineStart: TREE_HORIZONTAL_SEPARATION,
    overflow: "hidden",
    textOverflow: "ellipsis",
    userSelect: "none",
    visibility: isDragging ? "hidden" : void 0,
    whiteSpace: "nowrap"
  };
});

export { TreeLabel };
